import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { actions } from "../redux/authRedux";

export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Dispatch logout action
    dispatch(actions.login(null)); // hoặc actions.logout() nếu có
  }, [dispatch]);

  // Sau khi logout, redirect về login
  return <Navigate to="/auth/login" replace />;
}
